var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddElement = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5335 35.2617H27.4335V36.2617H34.5335L34.5335 43.3617L35.5335 43.3617L35.5335 36.2617L42.6335 36.2617V35.2617L35.5335 35.2617V28.1617L34.5335 28.1617L34.5335 35.2617Z",
    fill: "#59BD39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0887 55.0446C29.346 61.9281 42.4927 61.5861 51.4649 53.5762C61.7196 44.4216 62.6382 28.7174 53.5167 18.4999C44.3953 8.28242 28.6878 7.42078 18.4332 16.5754C10.9007 23.2999 8.40549 33.5583 11.2267 42.5803C11.9615 44.9301 13.057 47.196 14.518 49.2937",
    stroke: "#1B1B1B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddElement);
export default ForwardRef;